import { LangUri, Url } from '@catawiki/runtime-toolkit';

// TODO: Stop using langUri -> won't work for SSR pages
import {
  langUri as langUriUtil,
  wrapObjectWithGenerateLocale,
} from '@/shared/helpers/langUri';

export const offeredLotsUrl = langUriUtil.generatePath('/seller/offered-lots');

export const messagesPageUrl = langUriUtil.generatePath('/messages');

export const ordersPageUrl = langUriUtil.generatePath('/f/seller/orders');
export const bulkUploadUrl = '/v/lots/bulk_upload';

export const sellerFeedbackUrl = (sellerId: string | number) =>
  `/f/seller/${sellerId}/feedback`;

interface IUnsoldLotsHref {
  url: string;
  statuses: string[];
  HBOFilter?: boolean;
  search?: string;
}

export const unsoldLotsHref = ({
  url,
  statuses,
  HBOFilter = false,
  search = '',
}: IUnsoldLotsHref) =>
  `${url}?${Url.createSearch({
    statuses,
    ...Url.parseSearch(search, { ignoreQueryPrefix: true }),
    ...(HBOFilter && { highest_bid_offer: 'true' }),
  })}`;

export const createClientRoute = (locale: string, url: string) =>
  `/${locale}${url}`;

export const SELLER_CLIENT = {
  sellerLiveLots: '/v/lots/live',
  sellerSubmissions: '/v/lots/submissions',
  sellerUnsoldLots: '/v/lots/unsold',
  sellerDashboard: '/v/dashboard',
  sellerOverview: '/v/overview',
  sellerAnalytics: '/v/analytics',
  sellerUILotSubmissionBase: '/v/lot',
  sellerRegister: '/v/register',
  sellerUnpaidLots: '/v/lots/unpaid',
  sellerPerformanceDashboard: '/v/performance',
  sellerNewSubmission: '/v/lot/new',
};

export const ORDERS_CLIENT = {
  sellerOrderList: '/f/seller/orders',
};

export const PAYMENTS_CLIENT = {
  sellerPaymentsList: '/f/seller/payments',
};

export const INVOICES_CLIENT = {
  sellerInvoices: '/f/seller/invoices',
};

export const buyerFetchLotsEndpoint = (lotsIds: number[]) =>
  `/buyer/api/v1/lots?ids=${lotsIds.join(',')}`;

export const buyerFetchLotBidsEndpoint = (lotsIds: (string | number)[]) =>
  `/buyer/api/v3/bidding/lots?ids=${lotsIds.join(',')}`;

export const sellerSuccessFeeHelpPath =
  '/help/seller-success-fee-vat/what-is-the-seller-success-fee';

export const sellerSuccessFeeHelpUrl = (locale: string) =>
  LangUri.generateLocalePath(locale, sellerSuccessFeeHelpPath);

export const sellerSuccessfulSellingHelpUrl = (locale: string) =>
  LangUri.generateLocalePath(
    locale,
    '/help/tips-for-successful-selling/how-to-give-buyers-the-best-experience'
  );

export const buyerFetchExpertsEndpoint = '/buyer/api/v1/experts/featured';

export const sellerHelpUrl = '/help/seller';

export const accountsUrl = wrapObjectWithGenerateLocale({
  register: '/accounts/register',
  login: '/accounts/login',
  verify: '/accounts/seller/verify',
  profile: '/accounts/settings/seller_profile',
  settings: '/accounts/settings/account',
});

export const sellerOrderDetailsUrl = (orderId: number) =>
  `/f/seller/orders/${orderId}`;

export const loginUrlWithRedirectToCurrent = () =>
  `/accounts/login?redirect_after=${window.location.pathname}`;

export const helpPagesUrl = wrapObjectWithGenerateLocale({
  sellerShippingInsurance: '/help/seller-shipping-costs/shipping-insurance',
  sellerPickupOnly:
    '/help/most-asked/when-and-how-do-i-arrange-the-pick-up-of-an-item',
  sellerSmartShipping: '/pages/p/smart-shipping',
  sellerBuyNow:
    '/help/submitting-lots/can-i-offer-a-buy-now-option-for-my-objects',
  sellerSetShippingCosts:
    '/help/seller-shipping-costs/when-and-how-can-i-set-correct-shipping-costs',
  sellerCombinedShipping:
    '/help/seller-shipping-costs/can-i-ship-multiple-objects-together-to-the-same-buyer',
});

const { sellerUILotSubmissionBase } = SELLER_CLIENT;

export const lotSubmissionRoutes = wrapObjectWithGenerateLocale({
  lotCreationPage: `${sellerUILotSubmissionBase}/new`,
  donePage: (id: number) => `${sellerUILotSubmissionBase}/${id}/done`,
  copyPage: (id: number, isDeprecationFlow = false) =>
    `${sellerUILotSubmissionBase}/${id}/copy${Url.createSearch(
      {
        deprecation: isDeprecationFlow || undefined,
      },
      { addQueryPrefix: true }
    )}`,
  editPage: (id: number, isCopied = false) =>
    `${sellerUILotSubmissionBase}/${id}/edit${Url.createSearch(
      {
        isCopied: isCopied || undefined,
      },
      { addQueryPrefix: true }
    )}`,
  selectObjectTypePage: (id: number) =>
    `${sellerUILotSubmissionBase}/${id}/select`,
});

export const getLDPLink = (id: number | string) =>
  langUriUtil.generatePath(`/l/${id}`);

export const SELLER_ACCOUNT_URL = langUriUtil.generatePath(
  '/accounts/settings/account'
);
export const contactUsUrl = (source: string) =>
  `${langUriUtil.generatePath('/f/help/contact-us')}${Url.createSearch(
    { source },
    { addQueryPrefix: true }
  )}`;

export const getLotOrderLink = (orderId: number | string) =>
  langUriUtil.generatePath(`/f/seller/orders/${orderId}`);

export const getLotInvoiceLink = (lotId: number | string) =>
  langUriUtil.generatePath(`/finance/invoices/lots/${lotId}/seller`);

export const getLotReceiptLink = (orderId: number | string) =>
  langUriUtil.generatePath(`/f/seller/orders/${orderId}/receipt`);

export const APP_URL = 'https://app.adjust.com/v8wodbh_owm7xlg';
